'use strict';

const VK_SIGNUP={
  provider:'klaviyo',
  klaviyo:{companyId:'XfWDpn',listId:'Syqsap',source:'Skindiver Mark II — teaser banner'},
  endpoint:{url:'',headers:{}}
};

(function(){
 const banner=document.querySelector('.vk-banner');if(!banner)return;
 const form=banner.querySelector('.vk-form'),input=form.elements.email,button=form.querySelector('button[type=submit]'),status=form.querySelector('.vk-status');
 const label=button.innerHTML,EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
 const say=t=>{status.textContent=t};

 input.addEventListener('input',()=>{banner.classList.remove('is-invalid');input.removeAttribute('aria-invalid')});

 async function send(email){
  if(VK_SIGNUP.provider==='klaviyo'){
   const k=VK_SIGNUP.klaviyo;
   const payload={data:{type:'subscription',attributes:{custom_source:k.source,profile:{data:{type:'profile',attributes:{email,properties:{skindiver_mark_2_early_access:true,skindiver_mark_2_source:k.source},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:k.listId}}}}};
   const r=await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(k.companyId)}`,{method:'POST',headers:{'Content-Type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2026-10-15'},body:JSON.stringify(payload),signal:AbortSignal.timeout(15000)});
   if(r.status!==202)throw new Error(r.status===429?'Please wait a moment before trying again.':'We couldn’t save your email. Please try again.');
   return true;
  }
  if(VK_SIGNUP.provider==='endpoint'&&VK_SIGNUP.endpoint.url){
   const r=await fetch(VK_SIGNUP.endpoint.url,{method:'POST',headers:{'Content-Type':'application/json',...VK_SIGNUP.endpoint.headers},body:JSON.stringify({email,consent:true,source:'skindiver-mark-2-teaser-banner'}),signal:AbortSignal.timeout(15000)});
   if(!r.ok)throw new Error('We couldn’t save your email. Please try again.');
   return true;
  }
  return false; // no integration configured
 }

 form.addEventListener('submit',async e=>{
  e.preventDefault();
  if(form.elements.website.value)return; // honeypot
  const email=input.value.trim();
  if(!EMAIL.test(email)){banner.classList.add('is-invalid');input.setAttribute('aria-invalid','true');say('Please enter a valid email address.');input.focus();return}
  if(!form.elements.consent.checked){say('Please tick the box to receive the launch emails.');form.elements.consent.focus();return}
  button.disabled=true;button.innerHTML='<span class="vk-cta">Sending…</span>';say('');
  try{
   const sent=await send(email);
   if(!sent){say('Signup is not connected yet: nothing was sent.');button.disabled=false;button.innerHTML=label;return}
   form.classList.add('is-done');button.innerHTML='<span class="vk-cta">You’re on the list</span><span class="vk-arrow" aria-hidden="true">✓</span>';
   say('You’re on the list. Look out for the full reveal on November 11.');
   form.querySelectorAll('input').forEach(i=>i.disabled=true);
  }catch(err){
   say(err.name==='TimeoutError'?'The connection timed out. Please try again.':err.message==='Failed to fetch'?'We couldn’t connect. Please check your connection and try again.':err.message);
   button.disabled=false;button.innerHTML=label;
  }
 });
})();

